import { mapperToOption } from '@/views/components/selects/mappers/mapperToOption'

const getValue = (object, property = 'value') =>
    object ? object[property] : null

export const mapperFormToApi = form => {
    const {
        id,
        title,
        type,
        description,
        mobilityDescription,
        hasMobility,
        period,
        departments,
    } = form
    return {
        id,
        type,
        title,
        period,
        description: description,
        has_mobility: hasMobility,
        mobility_description: mobilityDescription,
        interested_areas: departments.map(department => {
            return {
                section_id: getValue(department),
            }
        }),
    }
}

export const mapperApiToForm = data => {
    const {
        id,
        type,
        title,
        description,
        mobility_description,
        has_mobility,
        period,
        interested_areas,
    } = data

    return {
        id,
        type,
        title,
        period,
        description,
        hasMobility: has_mobility,
        mobilityDescription: mobility_description,
        departments: interested_areas.map(interestedArea => {
            const { area } = interestedArea
            return mapperToOption(area, 'id', 'name')
        }),
    }
}
